import { SlidingDrawerComponent } from 'components/main/sliding-drawer/sliding-drawer.component'
export default SlidingDrawerComponent
